// Only `features` stays in hub — it's the hub's feature inventory.
// Everything else (info, notifications, secretsAdmin, tenantProfile,
// apiToken, clientApplication, globalConfig, tenantConfig, tenant, role,
// client, user, userProfile, core.actions) lives in
// `core-fe-lib/components-shadcn/i18n/en-US/core.ts` and is merged in
// via `./index.ts`.
export default {
  features: {
    title: "Features",
    care: "Care",
    scholar: "Scholar (Exam Correction)",
    aiemployee: "AI Employee",
    slide: "Slides",
    credit: "Credits",
    lms: "Learning (LMS)",
    marketresearch: "Market Research",
  },
};
